import { render, staticRenderFns } from "./TokenStatusSection.vue?vue&type=template&id=8aa53154&scoped=true&"
import script from "./TokenStatusSection.vue?vue&type=script&lang=js&"
export * from "./TokenStatusSection.vue?vue&type=script&lang=js&"
import style0 from "./TokenStatusSection.vue?vue&type=style&index=0&id=8aa53154&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa53154",
  null
  
)

export default component.exports